//DESERTLAND content loader

import { HomeContent } from './content/home';
import { PlantContent } from './content/plant';
import { TipsContent } from './content/tips';
import { AboutContent } from './content/about';
import { ContactContent } from './content/contact';
import { IdeasContent } from './content/ideas';
import { LearnmoreContent } from './content/learnmore';
import { ResourcesContent } from './content/resources';
import { AcknowledgeContent } from './content/acknowledge';
import { BibliographyContent } from './content/bibliography';
import { HistoryContent } from './content/history';
// import { TriviaContent } from './content/trivia';

    
//DESERTLAND.Content = 
export const Content = {
    
    Home: new HomeContent(),
    
    Tips: new TipsContent(),
    
    Plant: new PlantContent(),
    
    Learnmore: new LearnmoreContent(),
    About: new AboutContent(),
    Contact: new ContactContent(),
    Ideas: new IdeasContent(),
    Resources: new ResourcesContent(),
    Acknowledge: new AcknowledgeContent(),
    Bibliography: new BibliographyContent(),
    History: new HistoryContent(),
    Trivia: new HomeContent(),
    //     init(params) {
    //         console.log("Content.Trivia TODO");
    //     }
    // }
    
};
